// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1065":"c8fe7020","2081":"588889d6","2147":"588889d6","4381":"588889d6","4683":"588889d6","5112":"588889d6","5273":"588889d6","5653":"588889d6","6533":"588889d6","6887":"588889d6","7950":"588889d6","7995":"588889d6","8061":"001a37af","9261":"588889d6"}[chunkId] + ".chunk.css";
};